import React from 'react';
import { TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { RegisterData } from '../../../../../types/auth';

const PersonalStep = () => {
  const { control, formState: { errors } } = useFormContext<RegisterData>();

  return (
    <>
      <Controller
        name="firstName"
        control={control}
        rules={{
          required: 'First name is required',
        }}
        render={({ field }) => (
          <TextField
            {...field}
            margin="normal"
            required
            fullWidth
            id="firstName"
            label="First Name"
            autoComplete="given-name"
            error={!!errors.firstName}
            helperText={errors.firstName?.message}
            inputProps={{ 'data-testid': 'student-firstName-input' }}
          />
        )}
      />

      <Controller
        name="lastName"
        control={control}
        rules={{
          required: 'Last name is required',
        }}
        render={({ field }) => (
          <TextField
            {...field}
            margin="normal"
            required
            fullWidth
            id="lastName"
            label="Last Name"
            autoComplete="family-name"
            error={!!errors.lastName}
            helperText={errors.lastName?.message}
            inputProps={{ 'data-testid': 'student-lastName-input' }}
          />
        )}
      />
    </>
  );
};

export default PersonalStep;
